// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__5bK3Z","card":"NotFound_card__OmMEH","code":"NotFound_code__n3FlE","lead":"NotFound_lead__ctriQ"};